import React, {
  useEffect,
  useState,
} from 'react'
import { connect } from 'react-redux'
import api from '../../api'
import ButtonPrimary from '../ui/ButtonPrimary'
import ButtonTransparent from '../ui/ButtonTransparent'
import './index.css'

const VarianceBlock = (props) => {
  const [ lastRunType, setLastRunType ] = useState('')
  const [ lastRunStatus, setLastRunStatus ] = useState('')
  const lastRun = props.orders[props.orders.length - 1]



  useEffect(() => {
    if (lastRun) {
      setLastRunType(lastRun.type)
      setLastRunStatus(lastRun.status)
      if (lastRun.type === 'final_run' && lastRun.status === 'completed') {
        setLastRunType(lastRun.type)
        setLastRunStatus(lastRun.status)

      }
    } else {

    }

  }, [ lastRun ])


  const confirmButton = (status) => {
    switch (status) {
      case 'scan_completed':
        return (
          <input
            type="submit"
            value="Complete Job"
            className="job-details__form-submit btn btn--primary"
          />
        )
      default:
        return null
    }
  }

  const abortJob = async (e) => {
    e.preventDefault()
    if (props.job.status === 'scheduled') {
      await props.updateJobStatus(props.job.UUID, 'canceled')
    } else {
      await api.abortJob(props.job.UUID)
      window.history.go()
    }
  }

  return (
    <div className="variance">
      <h3 className="variance__title">{lastRunStatus === 'completed' && lastRunType === 'final_run' ? null : 'Variance'}</h3>
      <div className="variance__body">
        {lastRunStatus === 'completed' && lastRunType === 'final_run' ? (
            <div className="job-details__form-group job-details__controls">
              {confirmButton('scan_completed')}
              <ButtonTransparent
                name={
                  props.status === 'scheduled' ? 'Cancel Job' : 'Abort Job'
                }
                onClick={abortJob}
                className="job-details__form-submit btn btn--transparent"
              />
            </div>
          ) :
          <>
            <ButtonPrimary
              name={props.orders.length === 0 ? 'Start Variance' : 'View Variance'}
              onClick={props.onClickViewProgress}
            />
            <ButtonTransparent
              name="Abort Job"
              onClick={abortJob}
              className="job-details__form-submit btn btn--transparent-sick"
            />
          </>
        }
      </div>
    </div>
  )

}

const mapStateToProps = ({ data: { orders } }) => ({ orders })


export default connect(
  mapStateToProps,
  [],
)(VarianceBlock)
